module.exports = __webpack_public_path__ + "assets/RetinaNarr-LightItalic.ad46ab1a8d2674dda32f9783a5c8aaa8.woff";